// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1Vzmm","inputWrap":"styles_inputWrap__3ux50","input":"styles_input__2GkaQ"};